import * as Validator from 'yup'

export default Validator.number()
  .required()
  .positive()
  .max(20000)
  .typeError('Please enter a number')
  .label('Radius')
